import extractTextFromMarkdown from './extractTextFromMarkdown'

const string = {
  extractTextFromMarkdown,
}

export default string
